module.exports = __webpack_public_path__ + "static/media/SR303-W1L1-P6C Copy.737a501f.png";